import type { RefObject } from 'react';

import { DataTestIds } from '@repo/frontend-shared';
import { SDSText } from '@repo/sds/SDSText';

import { type ErrorSummaryItem, focusFormField } from './form-error-summary-utils';

interface FormErrorSummaryProps {
  items: ErrorSummaryItem[];
  containerRef: RefObject<HTMLDivElement | null>;
  titleId: string;
}

export function FormErrorSummary({ items, containerRef, titleId }: FormErrorSummaryProps) {
  if (items.length === 0) return null;

  return (
    <div
      ref={containerRef}
      role="alert"
      aria-labelledby={titleId}
      tabIndex={-1}
      data-testid={DataTestIds.COMMON.FORM_ERROR_SUMMARY}
    >
      <SDSText id={titleId} type="body-large-bold" text="Please fix the following before continuing:" />
      <ul>
        {items.map(item => (
          <li key={`${item.field}:${item.message}`}>
            <button
              type="button"
              data-testid={DataTestIds.COMMON.FORM_ERROR_SUMMARY_ITEM}
              onClick={() => focusFormField(item.field)}
            >
              {item.message}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
